import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { GetAdminsMangementService } from './get-admins.service';
import { DeleteAdminService } from './delete-admin.service';
import { Report, RowActions } from '../../../report/report';
import { AlertDialogComponent } from '../../../../../shared/components/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-mangement',
  templateUrl: './mangement.component.html',
  styleUrls: ['./mangement.component.scss']
})
export class MangementComponent implements OnInit {
  totalNumberOfRecords = 0;
  adminManagementReportData: any[] = [];
  requestBody: Report = {};
  loading = false;
  displayedColumns = [
    'first_name',
    'last_name',
    'email',
    'name']

  displayTableColumns = {
    'first_name': 'First Name',
    'last_name': 'Last Name',
    'email': 'Email',
    'name': 'Role',

  };

  rowActions: RowActions[] = [
    {
      actionName: 'delete',
      actionType: 'icon',
      iconClass: 'fa-trash',
    },
    {
      actionName: 'edit',
      actionType: 'icon',
      iconClass: 'fa-edit',
    },
  ];

  constructor(
    public getAdminsMangementService: GetAdminsMangementService,
    private deleteAdminService: DeleteAdminService,
    public dialog: MatDialog,
    private router: Router
  ) { }

  async ngOnInit() {
    this.getAdminsMangementService.activateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.getAdminsMangementService.loader().subscribe(val => (this.loading = val));
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.getAdminsMangementService.loader().subscribe(val => (this.loading = val));
  }

  async searchChange(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.getAdminsMangementService.loader().subscribe(val => (this.loading = val));
    }
    this.updateTable();
  }
  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.getAdminsMangementService.loader().subscribe(val => (this.loading = val));
  }

  async updateTable() {
    this.getAdminsMangementService.activateLoader();
    this.getAdminsMangementService.setParams(this.requestBody);
    const report = await this.getAdminsMangementService.make();
    //console.log(report);
    this.adminManagementReportData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }


  onRowAction(event: any) {
    if (event.action === 'delete') {
      //  console.log(event.key.id)
      this.deleteAdmin(event.key.id);
    }
    if (event.action === 'edit') {
      //  console.log(event.key)
      this.router.navigate(['/admin/actions/admin/edit/', event.key.id]);
    }
  }

  async deleteAdmin(id: number) {
    //console.log(id);
    try {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        data: {
          message: 'Are you sure you want to delete it',
          question: true
        }
      });
      const result = await dialogRef.afterClosed().toPromise();
      if (!result) {
        return;
      }
      this.deleteAdminService.setParams({ id });
      const res = await this.deleteAdminService.make();
      console.log(res);
      this.updateTable();
      this.getAdminsMangementService.loader().subscribe(val => (this.loading = val));
    } catch (err) {
      console.log(err);
    }
  }

}

